module.exports = __webpack_public_path__ + "img/insert_drive_file.2259b2a1.svg";